module.exports = __webpack_public_path__ + "img/HP-sec07-img-01.38033413.jpg";